<fe-header style="z-index: 10000"></fe-header>
<main>
    <fe-href-subheader [breadcrumbs]="breadcrumbs"></fe-href-subheader>
    <fe-container-company-policies
        [content]="rentalPolicyContent"
    ></fe-container-company-policies>
</main>
<fe-footer></fe-footer>
